import { render, staticRenderFns } from "./CatchingAnimal.vue?vue&type=template&id=7294730a&scoped=true&"
import script from "./CatchingAnimal.vue?vue&type=script&lang=js&"
export * from "./CatchingAnimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7294730a",
  null
  
)

export default component.exports